export default {
  gold: '#e0be7a',
  dark: '#1c1b1a',
  gray: '#242322',
  white: '#fff',
  green: '#91bc6a',
  red: '#c96161',
};
